import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { Title } from 'Components/frameworks/title/Title';
import { AlternativeDateSuggestionImmersive } from 'Components/widgets/alternative-proposals/alternative-date-suggestion/AlternativeDateSuggestionImmersive';
type Props = {
  children: ReactNode;
  className?: string;
  immersiveResort?: Readonly<{
    image?: string;
    name: string;
  }>;
  onClose?: () => void;
  title: string;
};
export const AlternativeSuggestions = ({
  children,
  className,
  immersiveResort,
  onClose,
  title,
}: Props) => {
  const { isTablet } = useResponsive();
  return (
    <div className={classnames(className)}>
      <Title className="mb-20" theme="title-brand-n1">
        {title}
      </Title>

      <div className="flex gap-20">
        {isTablet ? (
          <div className="grid grid-cols-1 gap-20 sm:grid-cols-2">{children}</div>
        ) : (
          <Scrollable
            backwardLabel={t('common.scrollBackward')}
            className="-mx-20"
            forwardLabel={t('common.scrollForward')}
          >
            <div className="flex gap-10 px-20">{children}</div>
          </Scrollable>
        )}

        {immersiveResort && (
          <AlternativeDateSuggestionImmersive onClose={onClose} resort={immersiveResort} />
        )}
      </div>
    </div>
  );
};
